export enum SDPTariffChoiceEnum {
  SOCIAL = 'SOCIAL',
  NONE = 'NONE',
}
